module.exports = __webpack_public_path__ + "img/gamma3_ex_p2.38967c96.jpg";